/**
 * 管理画面: POST 商品情報（product_id）。【SRPF0024】
 * 成功時はレスポンスの data オブジェクトのみ resolve（status/message はサーバで検証済み）。
 *
 * URL の解決順: (1) window.jpenergyAdminProductInfoUrl（任意のレガシー上書き）
 * (2) Livewire ItemSelectorModal が出力する .jpenergy-admin-product-info-url-field（route 生成）
 *
 * @param {number|string} productId
 * @returns {Promise<Record<string, unknown>>}
 */
function jpenergyResolveAdminProductInfoUrl() {
    const fromWindow = window.jpenergyAdminProductInfoUrl;
    if (typeof fromWindow === 'string' && fromWindow !== '') {
        return fromWindow;
    }
    const holder = document.querySelector('.jpenergy-admin-product-info-url-field');
    if (holder && typeof holder.value === 'string' && holder.value !== '') {
        return holder.value;
    }

    return null;
}

function jpenergyFetchAdminProductById(productId) {
    return new Promise((resolve, reject) => {
        const requestUrl = jpenergyResolveAdminProductInfoUrl();
        if (requestUrl === null) {
            reject(
                new Error(
                    'Admin product info URL is not set: add <livewire:item-selector-modal /> or window.jpenergyAdminProductInfoUrl',
                ),
            );
            return;
        }

        const showWaitModal = typeof window.jpenergyShowAjaxWaitModal === 'function';
        const hideWaitModal = typeof window.jpenergyHideAjaxWaitModal === 'function';
        if (showWaitModal) {
            window.jpenergyShowAjaxWaitModal();
        }

        $.ajax({
            url: requestUrl,
            method: 'POST',
            dataType: 'json',
            data: {
                product_id: productId,
            },
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .always(() => {
                if (hideWaitModal) {
                    window.jpenergyHideAjaxWaitModal();
                }
            })
            .done((body) => {
                const statusOk = Number(body?.status) === 1;
                if (statusOk && body.data !== undefined && body.data !== null) {
                    resolve(body.data);
                    return;
                }
                const fallbackMessage =
                    typeof body?.message === 'string' && body.message !== ''
                        ? body.message
                        : 'Invalid product info response';
                reject(new Error(fallbackMessage));
            })
            .fail((jqXHR) => {
                const message =
                    jqXHR.responseJSON && typeof jqXHR.responseJSON.message === 'string'
                        ? jqXHR.responseJSON.message
                        : jqXHR.statusText || 'Request failed';
                const error = new Error(message);
                error.status = jqXHR.status;
                error.body = jqXHR.responseJSON;
                reject(error);
            });
    });
}

window.jpenergyFetchAdminProductById = jpenergyFetchAdminProductById;

export { jpenergyFetchAdminProductById };
